import { z } from "zod";
import {
  dailyLogResourceGroupSchema,
  dailyLogSubmitRequestResourceSchema,
  dailyLogSubmitRequestTagSchema,
  dailyLogSubmitResponseImageSchema,
} from "./submitDailyLogSchema";

const userSchema = z.object({
  id: z.number(),
  name: z.string(),
  avatar_url: z.string().nullable(),
});

const dailyLogEditImagesSchema = z.object({
  created: z.array(z.string()),
  existing_ids: z.array(z.number()),
});

export const dailyLogEditRequestSchema = z.object({
  description: z.string(),
  location: z.string(),
  date: z.string(),
  weather: z.string(),
  temperature: z.string(),
  temperature_unit: z.literal("F"),
  precipitation: z.string(),
  precipitation_unit: z.literal("MM"),
  process_rate: z.string(),
  tags: z.array(dailyLogSubmitRequestTagSchema),
  workforces: z.array(dailyLogSubmitRequestResourceSchema),
  equipments: z.array(dailyLogSubmitRequestResourceSchema),
  images: dailyLogEditImagesSchema,
});

export const dailyLogEditResponseSchema = z.object({
  modified_at: z.string(),
  id: z.number(),
  status: z.string(),
  project_id: z.number(),
  description: z.string(),
  user: userSchema,
  location: z.string(),
  date: z.string(),
  d_day: z.string(),
  weather: z.string(),
  temperature: z.string(),
  temperature_unit: z.string(),
  precipitation: z.string(),
  precipitation_unit: z.string(),
  process_rate: z.string(),
  tags: z.array(dailyLogSubmitRequestTagSchema),
  workforce: dailyLogResourceGroupSchema.optional(),
  equipment: dailyLogResourceGroupSchema.optional(),
  images: z.array(dailyLogSubmitResponseImageSchema),
});

export type DailyLogEditRequest = z.infer<typeof dailyLogEditRequestSchema>;
export type DailyLogEditResponse = z.infer<typeof dailyLogEditResponseSchema>;
